import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ROSE_COLOR_MAP = {
  red: "https://arizonaroses.com/images/Rose-Colors/red-roses.png",
  pink: "https://arizonaroses.com/images/Rose-Colors/pink-roses.png",
  yellow: "https://arizonaroses.com/images/Rose-Colors/yellow-roses.png",
  white: "https://arizonaroses.com/images/Rose-Colors/white-roses.png"
};

export default function VasePreview({ design, roseColor, className = "" }) {
  const normalizedColor = roseColor?.toLowerCase();
  const roseImage = ROSE_COLOR_MAP[normalizedColor];
  
  // Determine which design image to use based on main_image_index
  const designImage = design 
    ? (design.main_image_index === 1 ? design.image_url_2 : design.image_url)
    : null;

  return (
    <div className={`relative aspect-[3/4] bg-white rounded-[2rem] overflow-hidden shadow-inner border border-sage-50 ${className}`}>
      {/* Bottom Layer: Vase Design */}
      <AnimatePresence mode="wait">
        {designImage && (
          <motion.img
            key={designImage}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            src={designImage}
            alt={design?.name}
            className="absolute inset-0 w-full h-full object-contain p-4 z-10"
          />
        )}
      </AnimatePresence>

      {/* Top Layer: Roses */}
      <AnimatePresence mode="wait">
        {roseImage ? (
          <motion.img
            key={roseImage}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            src={roseImage}
            alt={`${roseColor} Roses`}
            className="absolute inset-0 w-full h-full object-contain p-4 z-20"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-sage-200 z-20">
            <span className="text-xs font-bold uppercase tracking-widest">Select Color</span>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}